export var View;
(function (View) {
    View["List"] = "list";
    View["Chart"] = "chart-mobile";
    View["Visual"] = "visual-mobile";
})(View || (View = {}));
export const VIEW_LIST = View.List;
export const VIEW_CHART = View.Chart;
export const VIEW_VISUAL = View.Visual;
